/* eslint-disable no-unused-vars */
import { Button, Divider, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import MDTypography from "components/MDTypography";
import React from "react";
import { Colors } from "utils/Constants";

function addButton({
  title = "",
  icon,
  suffixIcon,
  background,
  color,
  action,
  disabled = false,
  border = false,
  borderColor = "var(--gray-300, #D0D5DD)",
  ml = pxToRem(16),
}) {
  return (
    <Button
      disableRipple
      disabled={disabled}
      sx={{
        marginLeft: ml,
        backgroundColor: background,
        borderRadius: pxToRem(0),
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", // ✅ Added shadow
        "&:hover": {
          backgroundColor: background,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // Optional hover shadow
          border: "none",
        },
        height: pxToRem(40),
        paddingX: pxToRem(16),
        border: border ? `1px solid ${borderColor}` : "none",
      }}
      onClick={() => action()}
    >
      <Icon fontSize={pxToRem(14)} sx={{ color }}>
        {suffixIcon}
      </Icon>
      <Divider
        orientation="vertical"
        sx={{ mx: pxToRem(4), width: pxToRem(1), background: Colors.BLACK }}
      />
      {title && (
        <MDTypography
          fontSize={pxToRem(14)}
          sx={{ color, marginLeft: pxToRem(4), lineHeight: pxToRem(20) }}
        >
          {title}
        </MDTypography>
      )}
      <Icon fontSize={pxToRem(14)} sx={{ color, marginLeft: pxToRem(8.6) }}>
        {icon}
      </Icon>
    </Button>
  );
}

export default addButton;
